import propEq from "ramda/src/propEq";

export const propIdEq = propEq("id");
